define('ordersBoardCardsView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'bootbox',
  'settings',
  'gmailUtils',
  'ordersMailsUtils',
  'moment',
  'notificationCenter',
  'ordersController',
  'ordersBoardCardView',
  'ordersBoardGroupView',
  'template!ordersBoardCardsView',
  'entities/orders'
], function (
    App,
    Module,
    Backbone,
    Marionette,
    _,
    bootbox,
    Settings,
    GmailUtils,
    OrdersMailsUtils,
    moment,
    NotificationCenter,
    Controller,
    CardView,
    GroupView,
    Tpl
) {
  'use strict';

  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    childViewContainer: '.cards-container',
    className: 'orders-board-kanban-cards-view',

    attributes: function () {
      return {
        'data-id': this.status//,
        //'data-params': encodeURI(this.model.get('params'))
      };
    },

    childViewOptions: function () {
      return {
        //users: this.options.users,
        statuses: this.options.statuses,
        status: this.status,
        type: this.options.type,
        boardView: this.options.boardView,
        kanbanView: this.options.kanbanView,
        mailParams: this.mailParams,
        cards: this
      };
    },

    childEvents: {
      'onDrag': function () {
        this.trigger('onDrag');
      },
      'onStopDrag': function () {
        this.trigger('onStopDrag');
      }
    },

    getChildView: function (model) {
      if (model.get('orders'))
        return GroupView;
      else
        return CardView;
    },

    ui: {
      title: '.title .text',
      count: '.title .count',
      oldestRequest: '.bottom .oldest-request',
      oldestWorkingHours: '.bottom .oldest-request .working-hours',
      closedFolderIcon: '.closed-folder-icon',
      openedFolderIcon: '.opened-folder-icon',
      showOnlyMyne: '.show-only-myne',
      quantity: '.quantity',
      price: '.price',
      folder: '.folder',
      filter: '.filter',
      cardsContainer: '.cards-container',
      loading: '.loading',
      lazyArea: '.lazy-area',
      sort: '.sort',
      selectAll: '.select-all',
      sortPanel: '.sort-panel',
      sortItem: '.sort-panel .item',
      resetSort: '.reset-sort-button',
      closeSort: '.sort-panel .close-button',
      minimize: '.minimize',
      minimizeIcon: '.minimize-icon',
      maximizeIcon: '.maximize-icon'
    },

    regions: {
      sortRegion: '.sort-region'
    },

    events: {
      'dblclick @ui.folder': 'openFolder',
      'click @ui.sort': 'onSort',
      'change @ui.showOnlyMyne': 'onShowOnlyMyneChange',
      'click @ui.sortPanel': 'onFilter',
      'click @ui.sortItem': 'onSortSelect',
      'click @ui.resetSort': 'resetSort',
      'click @ui.closeSort': 'onCloseSortPanel',
      'click @ui.selectAll': 'selectAll',
      'click @ui.minimize': 'toggleMinimize',
            'click @ui.oldestWorkingHours': 'onClickOldestHours'
    },

    initialize: function () {
      this.SortedCollection = Backbone.Collection.extend({
        comparator: _.bind(function (a, b) {

          if (this.sortData[this.model.get('status')].field !== '') {
            var dir = this.sortData[this.model.get('status')].dir;
            var field = this.sortData[this.model.get('status')].field;

            if (field === 'priority') {
              if (dir === 'ASC')
                if (a.get('priority') < b.get('priority')) return -1;
                else return 1;
              else if (a.get('priority') > b.get('priority')) return -1;
              else return 1;
            }

            if (field === 'price') {
              if (dir === 'ASC')
                if (a.get('price') < b.get('price')) return -1;
                else return 1;
              else if (a.get('price') > b.get('price')) return -1;
              else return 1;
            }

            if (field === 'deadlineDate') {
              if (dir === 'ASC')
                if (new Date(a.get('deadlineDate')) < new Date(b.get('deadlineDate'))) return -1;
                else return 1;
              else if (new Date(a.get('deadlineDate')) > new Date(b.get('deadlineDate'))) return -1;
              else return 1;
            }

            if (field === 'expShippingDate') {
              if (dir === 'ASC')
                if (new Date(a.get('expShippingDate')) < new Date(b.get('expShippingDate'))) return -1;
                else return 1;
              else if (new Date(a.get('expShippingDate')) > new Date(b.get('expShippingDate'))) return -1;
              else return 1;
            }

            if (field === 'payedByCustomer') {
              if (dir === 'ASC')
                if (a.get('payedByCustomer') < b.get('payedByCustomer')) return -1;
                else return 1;
              else if (a.get('payedByCustomer') > b.get('payedByCustomer')) return -1;
              else return 1;
            }

            if (field === 'date') {
              if (dir === 'ASC')
                if (new Date(a.get('createDate')) < new Date(b.get('createDate'))) return -1;
                else return 1;
              else if (new Date(a.get('createDate')) > new Date(b.get('createDate'))) return -1;
              else return 1;
            }
          }

          return 1;
        }, this)
      });

      this.collection = new this.SortedCollection();
      this.count = 0;
      this.status = this.model.get('statusConst');
      this.mailParams = null;
      this.filters = [];
      this.fetchRequest = null;
      this.fetchCountRequest = null;

      //-------------

      var sortStr = Settings.get('boardSort');

      if (sortStr && sortStr !== '')
        this.sortData = JSON.parse(sortStr);

      if (!this.sortData)
        this.sortData = {};

      if (!this.sortData[this.model.get('status')])
        this.sortData[this.model.get('status')] = {
          field: '',
          dir: ''
        };

      //-------------

      var params = this.model.get('params');

      if (params && params[0] === '{') {
        try {
          this.mailParams = JSON.parse(params);
        } catch (err) {
        }
      }
    },

    onBeforeDestroy: function () {
      if (this.observer)
        this.observer.disconnect();
      if (this.lazyObserver)
        this.lazyObserver.disconnect();
    },

    onShow: function () {
      NotificationCenter.getInstance().addListener(this, NotificationCenter.events.CHANGE_INFO_ORDER, _.bind(function (response) {
        if (response && response.content && response.content.poi) {
          var order = App.request('order:model', App.request('order:parse-list-data', response.content));

          if (order.get('status') !== this.status) {
            this.removeOrder(order);
            return;
          }

          if (order.get('commandType') !== this.options.type) {
            this.removeOrder(order);
            return;
          }

          if (order.get('archived') === true) {
            this.removeOrder(order);
            return;
          }

          var params = _.extend({
            status: this.status,
            types: this.options.type,
            purchaseOrderId: order.get('purchaseOrderId')
          }, this.getFiltersParams());

          $.ajax({
            type: 'GET',
            url: App.request('order:get-orders-count', params),
            success: _.bind(function (count) {
              if (count.totalCount > 0)
                this.addOrder(order);
              else
                this.removeOrder(order);
            }, this)
          });
        }
      }, this));

      this.options.filtersView.on('change', _.bind(this.filtersChange, this));

      this.observer = new window.IntersectionObserver(_.bind(function (aEntries) {
        if (aEntries.length > 0 && aEntries[0].isIntersecting) {
          this.isVisible = true;
          this.fetch();
        } else {
          this.isVisible = false;
        }
      }, this), {
        threshold: 0.1
      });

      this.observer.observe(this.el);

      this.lazyObserver = new window.IntersectionObserver(_.bind(function (aEntries) {
        if (aEntries.length > 0 && aEntries[0].isIntersecting)
          this.fetch();
      }, this), {
        root: this.ui.cardsContainer[0],
        rootMargin: '100px',
        threshold: 0.5
      });

      if (this.ui.lazyArea[0])
        this.lazyObserver.observe(this.ui.lazyArea[0]);

      //-------------

      $(window).click(_.bind(function (e) {
        if ($(e.target).closest('.sort-panel').length === 0)
          this.hideSortPanel();
      }, this));

      $(document).keyup(_.bind(function (e) {
        if (e.which === 27) this.options.kanbanView.hideSortPanels();
      }, this));

      //-------------

      //this.fetch();
    },

    resortView: function () {
      //console.log('resortView');
    },

    onRender: function () {
      this.renderSort();
      this.renderSortable();
      
      // Apply saved minimized state from cookie
      this.applyMinimizedState();

      //-------------------
      var title = this.model.get('status');
      if (this.model.get('status').indexOf(' / ') !== -1)
        title = this.model.get('status').split(' / ')[1];
      this.ui.title.html(title);

      //-------------------
      this.ui.folder.hide();
      this.ui.openedFolderIcon.hide();
      this.ui.closedFolderIcon.hide();

      if (this.model.get('isSubDirectory')) {
        this.ui.openedFolderIcon.show();
        this.ui.folder.css('display', 'flex');
      } else {
        if (this.model.get('childStatus') && this.model.get('childStatus').length > 0) {
          this.ui.closedFolderIcon.show();
          this.ui.folder.css('display', 'flex');
        }
      }

      //-------------------
      if (Settings.get('showOnlyMine' + this.status, true) === 'true')
        this.ui.showOnlyMyne.attr('checked', true);
      else
        this.ui.showOnlyMyne.attr('checked', false);

      //-------------------
      if (Settings.configValue('config.board.header.hideQuantity') === true)
        this.ui.quantity.hide();
      else
        this.ui.quantity.show();

      // Show minimize/maximize buttons only when advancedMode is enabled
      if (Settings.configValue('advancedMode') === true)
        this.ui.minimize.show();
      else
        this.ui.minimize.hide();
    },

    renderSort: function () {
      if (this.sortData[this.model.get('status')].field !== '')
        this.ui.sort.addClass('active');
      else
        this.ui.sort.removeClass('active');

      this.options.boardView.headerView.renderUnSortButton(this.options.kanbanView.getSortedViews());
    },

    fetch: function (force) {
      if (!this.isVisible && !force)
        return;

      var params = _.extend({
        status: this.status
      }, this.getFiltersParams());

      if (this.model.get('isSubDirectory'))
        params.excludeSubLevel = true;

      if (Settings.get('showOnlyMine' + this.status, true) === 'true')
        params.showOnlyMine = true;

      params.first = 0;
      _.each(this.collection.models, _.bind(function (model) {
        if (model.get('orders'))
          params.first += model.get('orders').length;
        else
          params.first++;
      }, this));
      params.pageSize = 30;

      if (this.sortData[this.model.get('status')].field !== '') {
        params.sord = this.sortData[this.model.get('status')].dir;
        params.sidx = this.sortData[this.model.get('status')].field;
      }

      if (this.options.type === 'offer')
        params.types = 'offer';

      if (this.collection.length === 0) {
        this.ui.loading.addClass('activated');
        this.ui.cardsContainer.removeClass('activated');
      }

      if (this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('order:get-orders', params),
        success: _.bind(function (items) {
          _.each(items, _.bind(function (item) {
            var order = App.request('order:model', App.request('order:parse-list-data', item));
            this.addOrder(order);
          }, this));

          if (this.lastObservedElement)
            this.observer.unobserve(this.lastObservedElement);

          this.sort();

          if (items.length === params.pageSize) {
            var lastChildView = this.children.last();

            if (lastChildView) {
              var el = lastChildView.el;
              this.observer.observe(el);
              this.lastObservedElement = el;
            }
          }

          if (!this.isDestroyed) {
            this.ui.loading.removeClass('activated');
            this.ui.cardsContainer.addClass('activated');
          }
        }, this)
      });

      this.fetchCount(force);
    },

    sort: function () {
      this.collection.sort();
      _.each(this.collection.models, _.bind(function (model) {
        if (model.get('orders'))
          model.get('orders').sort();
      }, this));
    },

    removeOrder: function (order) {
      this.children.each(_.bind(function (view) {
        if (view.model.get('orders'))
          view.removeOrder(order);
      }, this));
      this.collection.remove(order);
    },

    addOrder: function (order) {
      if (this.getOrder(order.get('purchaseOrderId')))
        return;

      var group = null;
      var position = 0;

      _.each(this.collection.models, _.bind(function (model) {
        if (model.get('endUserId') && model.get('endUserId') === order.get('endUserId') && model.get('orders'))
          group = model;
      }, this));

      if (!group) {
        var unGroupedOrder = null;

        _.each(this.collection.models, _.bind(function (model) {
          if (model.get('endUserId') &&
              model.get('endUserId') === order.get('endUserId') &&
              model.get('purchaseOrderId') !== order.get('purchaseOrderId') &&
              !model.get('orders'))
            unGroupedOrder = model;
        }, this));

        if (unGroupedOrder) {
          group = App.request('group-model', {
            priority: 0,
            endUserId: order.get('endUserId'),
            minimized: !this.options.filtersView.hasFilterExceptWebshop(),
            orders: new this.SortedCollection()
          });

          unGroupedOrder.set('grouped', true);
          unGroupedOrder.set('minimized', group.get('minimized'));

          group.get('orders').add(unGroupedOrder, {sort: false});

          this.collection.remove(unGroupedOrder, {sort: false});

          position = this.collection.models.length;
          if (order.get('position') >= 0)
            position = order.get('position');
          group.set('position', position);
          if (this.sortData[this.model.get('status')].field === '')
            this.collection.add(group, {at: position, sort: false});
          else
            this.collection.add(group, {sort: false});
        }
      }

      if (group) {
        order.set('grouped', true);
        order.set('minimized', group.get('minimized'));
        group.add(order);
        group.trigger('change:orders');
      } else {
        order.set('grouped', false);
        position = this.collection.models.length;
        if (order.get('position') >= 0)
          position = order.get('position');
        order.set('position', position);

        if (this.sortData[this.model.get('status')].field === '')
          this.collection.add(order, {at: position, sort: false});
        else
          this.collection.add(order, {sort: false});
      }
    },

    getOrder: function (purchaseOrderId) {
      var order = null;
      this.children.each(_.bind(function (view) {
        if (view.model.get('orders')) {
          order = view.getOrder(purchaseOrderId);
        } else {
          if (view.model.get('purchaseOrderId') === purchaseOrderId)
            order = view.model;
        }
      }, this));

      return order;
    },

    fetchCount: function (force) {
      if (!this.isVisible && !force)
        return;

      var params = _.extend({
            status: this.status,
            types: this.options.type
        }, this.getFiltersParams());
        var displayHours = false;
        if (Settings.configValue('advancedMode') === true) {
            var statusObj;
            if (this.options.statuses && this.options.statuses.models) {
                statusObj = _.find(this.options.statuses.models, _.bind(function (stat) {
                    return stat.get('statusConst') === this.status;
                }, this));
            }
            if (statusObj && statusObj.get('params')) {
                var statusParamJson = JSON.parse(statusObj.get('params'));
                if (statusParamJson && statusParamJson.statusSince) {
                    params.statusSince = statusParamJson.statusSince;
                    displayHours = true;
                }
            }
        }

      if (this.fetchCountRequest)
        this.fetchCountRequest.abort();

      this.fetchCountRequest = $.ajax({
        type: 'GET',
        url: App.request('order:get-orders-count', params),
        success: _.bind(function (count) {
          if (!this.isDestroyed) {
            this.count = count.totalCount;
            this.ui.count.html(this.count);
            this.ui.count.addClass('visible');

            var priceLocale = 'fr-BE';
            var configPriceLocale = Settings.configValue('priceLocale');
            if (configPriceLocale)
              priceLocale = configPriceLocale;

            var sPrice = new Intl.NumberFormat(priceLocale).format(count.totalPrice);
            this.ui.price.html('€ ' + sPrice);
            this.ui.quantity.html(count.totalQuantity + ' ' + _.i18n('common.pcs'));

            // Oldest request info (clickable working hours linking to POI)
            if (displayHours && count.oldestRequest && count.oldestRequest.poi) {
              var poi = count.oldestRequest.poi;
              var wh = count.oldestRequest.workingHours;
              var wm = count.oldestRequest.workingMinutes;
              var date = count.oldestRequest.date;

              var minutes = 0;
              if (typeof wm === 'number') minutes = wm;
              else if (typeof wh === 'number') minutes = wh * 60;

              var hoursText = '';
              if (typeof wm === 'number') {
                var h = Math.floor(wm / 60);
                var m = wm % 60;
                hoursText = h + 'h ' + m + 'm';
              } else if (typeof wh === 'number') {
                var h2 = Math.floor(wh);
                var m2 = Math.round((wh - h2) * 60);
                hoursText = h2 + 'h' + (m2 ? ' ' + m2 + 'm' : '');
              } else if (wh) hoursText = wh;

              this.ui.oldestWorkingHours
                .text(hoursText)
                .attr('title', date || '')
                .attr('data-poi', poi)
                .removeClass('wh-green wh-orange wh-red');

              if (minutes < 120) this.ui.oldestWorkingHours.addClass('wh-green');
              else if (minutes <= 240) this.ui.oldestWorkingHours.addClass('wh-orange');
              else this.ui.oldestWorkingHours.addClass('wh-red');

              this.ui.oldestRequest.show();
              this.$('.sep-left, .sep-right').show();
            } else {
              this.ui.oldestRequest.hide();
              this.$('.sep-left, .sep-right').hide();
            }
          }
        }, this)
      });
    },

    getFiltersParams: function () {
      var params = {};

      if (this.options.type === 'offer')
        params.types = 'offer';

      var filters = this.options.filtersView.model;

      // Check if any priority filter is set (user, poi, supplier-number, client-number)
      var hasPriorityFilter = filters.get('endUserId') !== '' ||
                              filters.get('purchaseOrderId') !== '' ||
                              filters.get('supplierNumber') !== '' ||
                              filters.get('clientNumber') !== '';

      if (hasPriorityFilter) {
        // Only include the priority filters, remove all others
        if (filters.get('endUserId') !== '')
          params.endUserId = filters.get('endUserId');
        if (filters.get('purchaseOrderId') !== '')
          params.purchaseOrderId = filters.get('purchaseOrderId');
        if (filters.get('supplierNumber') !== '')
          params.supplierNumber = filters.get('supplierNumber');
        if (filters.get('clientNumber') !== '')
          params.clientNumber = filters.get('clientNumber');

        return params;
      }

      _.each(filters.attributes, function (value, key) {
        if (key !== 'quantityFrom' &&
            key !== 'quantityTo' &&
            key !== 'priceFrom' &&
            key !== 'priceTo' &&
            key !== 'minOrderPrice' &&
            key !== 'dateFrom' &&
            key !== 'dateTo' &&
            key !== 'deadlineDateFrom' &&
            key !== 'deadlineDateTo' &&
            key !== 'productSupplierCode') {
          if (value !== '')
            params[key] = value;
        }
      }, this);

      if (filters.get('quantityFrom') !== '' || filters.get('quantityTo') !== '') {
        var quantityFrom = filters.get('quantityFrom');
        var quantityTo = filters.get('quantityTo');

        if (quantityFrom === '')
          quantityFrom = 0;
        if (quantityTo === '')
          quantityTo = 999999999999;

        params.quantity = quantityFrom + '-' + quantityTo;
      }

      var minOrderPrice = filters.get('minOrderPrice');
      if (filters.get('priceFrom') !== '' || filters.get('priceTo') !== '' || minOrderPrice) {
        var priceFrom = filters.get('priceFrom');
        var priceTo = filters.get('priceTo');

        if (priceFrom === '')
          priceFrom = 0;
        if (priceTo === '')
          priceTo = 999999999999;

        if (minOrderPrice && Number(minOrderPrice) > Number(priceFrom))
          priceFrom = minOrderPrice;

        params.price = priceFrom + '-' + priceTo;
      }

      if (filters.get('dateFrom') !== '' && filters.get('dateTo') !== '') {
        params.dateFrom = filters.get('dateFrom');
        params.dateTo = filters.get('dateTo');
      }

      if (filters.get('deadlineDateFrom') !== '' && filters.get('deadlineDateTo') !== '') {
        params.deadlineDateFrom = filters.get('deadlineDateFrom');
        params.deadlineDateTo = filters.get('deadlineDateTo');
      }

      if (Settings.configValue('advancedMode') === true) {
        if(filters.get('productSupplierCode'))
          params.supplierProductBaseCode = filters.get('productSupplierCode');
      }

      return params;
    },

    filtersChange: function () {
      this.collection.reset();
      this.fetch(true);
    },

    openFolder: function () {
      var url = '';

      if (this.options.type === 'command')
        url = 'orders_kanban';
      if (this.options.type === 'offer')
        url = 'offers_kanban';

      if (!this.model.get('isSubDirectory') && this.model.get('childStatus') && this.model.get('childStatus').length > 0)
        App.navigate(url + '/' + this.status, {trigger: true});
      else
        App.navigate(url, {trigger: true});
    },

    onSort: function (e) {
      e.stopPropagation();

      if (this.isDestroyed)
        return;

      this.ui.sortItem.attr('data-dir', '');
      this.ui.sortItem.removeClass('selected');

      var sortField = this.sortData[this.model.get('status')].field;
      var dir = this.sortData[this.model.get('status')].dir;

      this.ui.sortPanel.find('.item[data-id="' + sortField + '"]').attr('data-dir', dir);

      this.options.kanbanView.hideSortPanels();
      this.ui.sortPanel.css('display', 'flex');
    },

    hideSortPanel: function () {
      if (this.isDestroyed)
        return;

      this.ui.sortPanel.hide();
    },

    onShowOnlyMyneChange: function (event) {
      Settings.set('showOnlyMine' + this.status, event.target.checked, true);
      this.collection.reset();
      this.fetch();
    },

    renderSortable: function () {

      this.ui.cardsContainer.sortable({
        connectWith: '.cards-container',
        placeholder: 'card-placeholder',
        opacity: 0.8,
        cursor: 'move',
        sort: _.bind(function() {
          // If the column is minimized, prevent horizontal scrolling
          if (this.$el.hasClass('minimized')) {
              this.ui.cardsContainer.scrollLeft(0);
          }
        }, this),
        start: _.bind(function (event, ui) {
          this.trigger('onDrag');

          this.options.kanbanView.multiSelect = [];

          var view = null;
          _.each(this.children._views, function (v) {
            if (v.$el[0] === ui.item[0])
              view = v;
          }, this);

          if (!view)
            return;

          this.options.kanbanView.multiSelect.push(view);

          this.children.each(_.bind(function (selectedView) {
            if (selectedView.isSelected() && selectedView.cid !== view.cid) {
              this.options.kanbanView.multiSelect.push(selectedView);
              selectedView.$el.hide();
            }
          }, this));
        }, this),
        receive: _.bind(function (event, ui) {
          var position = ui.item.index();
          ui.item.remove();
          this.trigger('onStopDrag');

          var orders = [];

          _.each(this.options.kanbanView.multiSelect, _.bind(function (view) {
            if (view.type === 'card')
              orders.push(view.model);
            if (view.type === 'group')
              orders = orders.concat(view.model.get('orders').models);
          }, this));

          _.each(orders, _.bind(function (order) {
            var oldStatus = order.get('status');
            order.updateStatus(this.status).done(_.bind(function () {
              try {
                this.options.kanbanView.getStatusView(oldStatus).fetchCount();
                this.options.kanbanView.getStatusView(this.status).fetchCount();
              } catch (e) {
                console.log(e);
              }
            }, this));

            try {
              if (order.get('status') === this.status)
                this.options.kanbanView.getStatusView(this.status).removeOrder(order);

              order.set('status', this.status);
              order.set('position', position);
              this.options.kanbanView.getStatusView(this.status).addOrder(order);
            } catch (e) {
              console.log(e);
            }
          }, this));

          //-------------------
          OrdersMailsUtils.check(orders, this.mailParams).done(_.bind(function () {
            var type = null;
            if(this.mailParams && this.mailParams.type)
              type = this.mailParams.type;

            if(type === 'sendMail') {
              var template = null;
              if(this.mailParams.params && this.mailParams.params.type)
                template = this.mailParams.params.type;

              if(template) {
                var status = null;
                _.each(Settings.configValue('mails.templates'), function (s) {
                  if (s.template === template)
                    status = s;
                }, this);

                if (status)
                  OrdersMailsUtils.sendMail(orders, status);
              }
            }
          }, this));

          //-------------------
          this.options.kanbanView.unSelectAll();

        }, this),
        stop: _.bind(function (event, ui) {
          this.trigger('onStopDrag');

          var view = null;
          _.each(this.children._views, function (v) {
            if (v.$el[0] === ui.item[0])
              view = v;
          }, this);

          if (view)
            view.model.set('position', ui.item.index());

          _.each(this.options.kanbanView.multiSelect, _.bind(function (view) {
            view.$el.css('display', 'flex');
          }, this));
        }, this)
      });
    },

    getSelectedCards: function () {
      var views = [];

      _.each(this.children._views, function (view) {
        if (view.model.get('orders'))
          views = views.concat(view.cardsView.getSelectedCards());
        else if (view.isSelected())
          views.push(view);
      });

      return views;
    },

    onSortSelect: function (event) {
      if (this.isDestroyed)
        return;

      if ($(event.currentTarget).attr('data-dir') === '') {
        this.ui.sortItem.attr('data-dir', '');
        this.ui.sortItem.removeClass('selected');
        $(event.currentTarget).attr('data-dir', 'DESC');
        $(event.currentTarget).addClass('selected');
        this.sortData[this.model.get('status')].field = $(event.currentTarget).attr('data-id');
        this.sortData[this.model.get('status')].dir = 'DESC';

      } else if ($(event.currentTarget).attr('data-dir') === 'DESC') {
        $(event.currentTarget).attr('data-dir', 'ASC');
        $(event.currentTarget).addClass('selected');
        this.sortData[this.model.get('status')].dir = 'ASC';

      } else if ($(event.currentTarget).attr('data-dir') === 'ASC') {
        $(event.currentTarget).attr('data-dir', '');
        $(event.currentTarget).removeClass('selected');
        this.sortData[this.model.get('status')].field = '';
        this.sortData[this.model.get('status')].dir = '';
      }

      Settings.set('boardSort', JSON.stringify(this.sortData));

      this.renderSort();
      this.collection.reset();
      this.fetch();
    },

    onCloseSortPanel: function () {
      this.hideSortPanel();
    },

    unSelectAll: function () {
      _.each(this.children._views, function (view) {
        if (view.model.get('orders'))
          view.unSelectAll();
        else
          view.unSelect();
      });
    },

    selectAll: function () {
      _.each(this.children._views, function (view) {
        view.select();
      });
    },

    resetSort: function () {
      if (this.isDestroyed)
        return;

      if (this.sortData[this.model.get('status')].field === '')
        return;

      this.sortData[this.model.get('status')].field = '';
      this.sortData[this.model.get('status')].dir = '';

      this.ui.sortItem.attr('data-dir', '');
      this.ui.sortItem.removeClass('selected');

      Settings.set('boardSort', JSON.stringify(this.sortData));

      this.renderSort();
      this.collection.reset();
      this.fetch();
    },
    
    onClickOldestHours: function (e) {
      e.preventDefault();
      if (this.isDestroyed)
        return;
      var poi = $(e.currentTarget).attr('data-poi');
      if (poi) {
        App.navigate('orders/' + poi, {trigger: true});
      }
    },
    
    toggleMinimize: function() {
      if (this.isDestroyed)
        return;
        
      // Toggle minimized state
      var isMinimized = this.$el.hasClass('minimized');
      
      if (isMinimized) {
        // Maximize the column
        this.$el.removeClass('minimized');
        this.ui.minimizeIcon.show();
        this.ui.maximizeIcon.hide();
        
        // Save state to cookie (false = not minimized)
        this.saveMinimizedState(false);
      } else {
        // Minimize the column
        this.$el.addClass('minimized');
        this.ui.minimizeIcon.hide();
        this.ui.maximizeIcon.show();
        
        // Save state to cookie (true = minimized)
        this.saveMinimizedState(true);
      }
    },
    
    saveMinimizedState: function(isMinimized) {
      // Create a unique cookie key for this column based on board type and status
      var cookieKey = 'boardColumn_' + this.options.type + '_' + this.status + '_minimized';
      
      // Save to cookie
      Settings.set(cookieKey, isMinimized, true);
    },
    
    loadMinimizedState: function() {
      // Create a unique cookie key for this column
      var cookieKey = 'boardColumn_' + this.options.type + '_' + this.status + '_minimized';
      
      // Get value from cookie (default to false if not found)
      var isMinimized = Settings.get(cookieKey, true);
      
      // Convert string to boolean if needed
      if (isMinimized === 'true') {
        isMinimized = true;
      } else if (isMinimized === 'false') {
        isMinimized = false;
      } else {
        isMinimized = false; // Default to not minimized
      }
      
      return isMinimized;
    },
    
    applyMinimizedState: function() {
      // Load the saved state from cookie
      var isMinimized = this.loadMinimizedState();
      
      // Apply the state to the column
      if (isMinimized) {
        this.$el.addClass('minimized');
        this.ui.minimizeIcon.hide();
        this.ui.maximizeIcon.show();
      } else {
        this.$el.removeClass('minimized');
        this.ui.minimizeIcon.show();
        this.ui.maximizeIcon.hide();
      }
    }
  });
});

